export default __webpack_public_path__ + "static/media/hesham.ff7f01fa.jpg";